function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm20 0a9 9 0 11-18 0 9 9 0 0118 0z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 9.48c0 2.628-2.838 2.669-2.838 3.64v.248c0 .26-.21.47-.47.47h-1.79a.47.47 0 01-.47-.47v-.34c0-1.4 1.062-1.96 1.865-2.41.688-.386 1.11-.648 1.11-1.16 0-.675-.862-1.124-1.56-1.124-.908 0-1.328.43-1.917 1.175a.47.47 0 01-.654.083l-1.09-.827a.471.471 0 01-.104-.641C9.008 6.764 10.188 6 12.024 6 13.947 6 16 7.501 16 9.48zM13.443 16.033c0 .908-.738 1.646-1.646 1.646a1.648 1.648 0 01-1.646-1.646c0-.908.738-1.646 1.646-1.646.908 0 1.646.738 1.646 1.646z",
  fill: "#000"
});

function SvgCircleQuestion(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCircleQuestion;